import { Grid } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { isEmptyArray } from '../../common/util.services';
import { getCostingDetail } from '../../costing/costing.services';
import './costing.component.scss';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';

const CostingPopup = (props: any) => {
  const rows: GridRowsProp = [];
  const [detailRows, setDetailRows] = useState(rows);
  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [popupRowData, setPopupRowData] = useState(null);

  const columns: GridColDef[] = [
    { field: 'serial', headerName: '#', filterable: false, sortable: false, width: 5 },
    //{ field: 'type', headerName: 'Type', filterable: false, sortable: false, width: 80 },
    { 
      field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 80,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>{params.row.code}</div> }
    },
    { field: 'dependency', headerName: 'Dependency', filterable: false, sortable: false, width: 100 },
    { field: 'description', headerName: 'Description', width: 150 },
    /*{
      field: 'specs', headerName: 'Specs', width: 70, filterable: false, sortable: false,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>Specs</div> }
    },*/
    { field: 'uom', headerName: 'UOM', filterable: false, sortable: false, width: 70 },
    { field: 'supplier', headerName: 'Supplier', filterable: false, sortable: false, width: 150 },
    {
      field: 'processLossPercentage', headerName: 'Proc Loss', filterable: false, sortable: false, width: 80,
      valueFormatter: (processLossPercentage: any) => processLossPercentage + '%'
    },
    { field: 'unitCost', headerName: 'Unit Cost', filterable: false, sortable: false, width: 80 },
    {
      field: 'consumption', headerName: 'Consumption', filterable: false, sortable: false, width: 110, 
      valueFormatter: (consumption: any) => consumption.toFixed(2)
    },
    {
      field: 'consumptionCost', headerName: 'Cost', filterable: false, sortable: false, width: 80,
      valueFormatter: (consumptionCost: any) => consumptionCost.toFixed(2)
    },
    { field: 'outputDesc', headerName: 'Output Details', filterable: false, sortable: false, width: 150 },
    //{ field: 'multiplier', headerName: 'Multiplier', filterable: false, sortable: false, width: 100 }
  ];

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getCostingDetail(props.costingId, appContext,
        (response: any) => {
          setDetailRows(response.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  const openSpecsPopup = (params: any) => {
    setPopupRowData(params.row);
    setOpenSpecs(true);
  }

  const handleCloseSpecs = () => {
    setOpenSpecs(false);
  }

  return (
    <div>
      <Grid container spacing={1}>
        <IGridComponent title='' rows={detailRows} columns={columns} getRowId={(row: any) => row.linkId} 
          apiRef={props.apiRef} showAction={false} hideFooterPagination={true} loading={loading}/>
        <IDialogComponent onClose={handleCloseSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
          dialogBody={<SpecsComponent data={popupRowData}/>} />
      </Grid>
    </div>
  );
}

export default CostingPopup;